import { useContext } from 'react';
import { GlobalContext } from '../GlobalProvider';

/**
 * Get an entity by its ID.
 * @param {string} entityId - The ID of the entity to fetch.
 * @param {Object} appData - The app data containing entities.
 * @returns {Object|null} - The entity object or null if not found.
 */
export const getEntityById = (entityId, appData) => {
    if (!appData || !appData.entities) return null;
    return appData.entities.find(entity => entity._id === entityId) || null;
};

/**
 * Get a sensor by its ID from all entities in the app.
 * @param {string} sensorId - The ID of the sensor to fetch.
 * @param {Object} appData - The app data containing entities and sensors.
 * @returns {Object|null} - The sensor object or null if not found.
 */
export const getSensorById = (sensorId, appData) => {
    if (!appData || !appData.entities) return null;
    for (const entity of appData.entities) {
        if (!entity.sensors) continue;
        const sensor = entity.sensors.find(sensor => sensor._id === sensorId);
        if (sensor) {
            return sensor;
        }
    }
    return null;
};

/**
 * Get all actions for a given entity by its ID.
 * @param {string} entityId - The ID of the entity to fetch actions for.
 * @param {Object} appData - The app data containing entities and actions.
 * @returns {Array} - An array of actions for the entity or an empty array if none found.
 */
export const getActionsByEntityId = (entityId, appData) => {
    if (!appData) return [];
    const entity = getEntityById(entityId, appData);
    return entity && entity.actions ? entity.actions : [];
};

/**
 * Hook to access the current app data from GlobalContext.
 * Provides utility functions bound to the current app.
 * @returns {Object} - Utility functions bound to the current app data.
 */
export const useAppUtilities = () => {
    const { fullApp } = useContext(GlobalContext);

  

    return {
        getEntityTypeById: (entityId) => getEntityById(entityId, fullApp),
        getSensorById: (sensorId) => getSensorById(sensorId, fullApp),
        getActionsByEntityId: (entityId) => getActionsByEntityId(entityId, fullApp),
    };
};
